<div class="aar-no-activity-container">
  {{message}}
</div>
